
ScrollReveal().reveal('.animate', {
  distance: '0px',
  origin: 'bottom',
  opacity: 0,
  duration: 0, // 禁用 ScrollReveal 的动画系统，改用 CSS
  reset: true,
  cleanup: true,
  viewOffset: { top: -window.innerHeight / 10, bottom: window.innerHeight / 10},
  beforeReveal: el => el.classList.add('reveal-active'),
  beforeReset: el => el.classList.remove('reveal-active'),
});
  


ScrollReveal().reveal('.line-move', {
duration: 0,
reset: true,
cleanup: true,
opacity: 1,
interval: 200, // 每个 span 依次触发
viewOffset: { top: 0, bottom: window.innerHeight / 10 },
beforeReveal(el) {
el.classList.add('underline-active');
},
beforeReset(el) {
el.classList.remove('underline-active');
}
});

(function() {
  function cleanCollectionTypeSwiper() {
    var path = window.location.pathname || '';
    var isExecutive = path.indexOf('executive') > -1 && path.indexOf('reception') === -1;
    var isReception = path.indexOf('reception') > -1 && path.indexOf('executive') === -1;
    if (!isExecutive && !isReception) return;

    document.querySelectorAll('.ct-container').forEach(function(container) {
      container.querySelectorAll('.swiper-ct-slide').forEach(function(slide) {
        var href = (slide.querySelector('a') && slide.querySelector('a').getAttribute('href') || '').toLowerCase();
        var title = (slide.textContent || '').toLowerCase();
        if (isExecutive && (href.indexOf('reception') > -1 || title.indexOf('reception') > -1)) {
          slide.remove();
        }
        if (isReception && (href.indexOf('executive') > -1 || title.indexOf('executive') > -1)) {
          slide.remove();
        }
      });

      if (!container.querySelector('.swiper-ct-slide')) {
        container.remove();
        return;
      }

      var swiperEl = container.querySelector('.swiper-ct');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanCollectionTypeSwiper);
  } else {
    cleanCollectionTypeSwiper();
  }
  window.addEventListener('load', cleanCollectionTypeSwiper);
  setTimeout(cleanCollectionTypeSwiper, 800);
  setTimeout(cleanCollectionTypeSwiper, 2000);
})();

(function () {
  if (window.nexProductVariantDropdownReady) return;
  window.nexProductVariantDropdownReady = true;

  function closeVariantDropdowns(exceptWrapper) {
    document
      .querySelectorAll(
        ".t4s-swatch__list .t4s-dropdown__wrapper.is-style-mb--false.is--opened"
      )
      .forEach(function (wrapper) {
        if (wrapper !== exceptWrapper) wrapper.classList.remove("is--opened");
      });

    document
      .querySelectorAll(".t4s-swatch__list [data-dropdown-open].is--clicked")
      .forEach(function (button) {
        var wrapper = document.getElementById(button.getAttribute("data-id"));
        if (!exceptWrapper || wrapper !== exceptWrapper)
          button.classList.remove("is--clicked");
      });
  }

  document.addEventListener(
    "click",
    function (event) {
      var item = event.target.closest(
        ".t4s-swatch__list .t4s-dropdown__wrapper.is-style-mb--false [data-dropdown-off]"
      );
      if (item) {
        setTimeout(function () {
          closeVariantDropdowns();
        }, 0);
        return;
      }

      var button = event.target.closest(
        ".t4s-swatch__list [data-dropdown-open]"
      );
      if (button) {
        var wrapper = document.getElementById(button.getAttribute("data-id"));
        if (!wrapper || !wrapper.classList.contains("is-style-mb--false"))
          return;

        event.preventDefault();
        event.stopPropagation();

        var shouldOpen = !wrapper.classList.contains("is--opened");
        closeVariantDropdowns(wrapper);
        button.classList.toggle("is--clicked", shouldOpen);
        wrapper.classList.toggle("is--opened", shouldOpen);

        var overlay = document.querySelector(".t4s-close-overlay");
        if (overlay) overlay.classList.remove("is--visible", "is--pindop");
        return;
      }

      if (
        !event.target.closest(
          ".t4s-swatch__list .t4s-dropdown__wrapper.is-style-mb--false"
        )
      ) {
        closeVariantDropdowns();
      }
    },
    true
  );
})();
